<template>
  <!-- 中间页面 -->
  <div class="about" v-loading="true"></div>
</template>
